import moment from 'moment';
import { useCallback } from 'react';
import { Views } from 'react-big-calendar';

interface ICalendarEvent {
  event: {
    title: string;
    description: string;
    status: string;
    isVacation?: boolean;
  };
  startingDate: Date;
  currentView: (typeof Views)[keyof typeof Views];
  setCurrentView: React.Dispatch<
    React.SetStateAction<(typeof Views)[keyof typeof Views]>
  >;
  setDate: React.Dispatch<React.SetStateAction<Date>>;
}

const AppointmentCalendarEvent = ({
  event,
  startingDate,
  setDate,
  currentView,
  setCurrentView,
}: ICalendarEvent) => {
  // destructuring the event object here
  const { title, description, status, isVacation } = event;

  // handler function to switch to day view on clicking event declared here
  const eventClickHandler = useCallback(() => {
    setCurrentView(Views.DAY);
    setDate(moment(startingDate).toDate());
  }, [startingDate, setCurrentView, setDate]);

  // rendering appointment calender custom event here
  return (
    <div
      title={title}
      onClick={eventClickHandler}
      className={`flex flex-col justify-between px-2 py-1 rounded-lg h-full ${
        status === 'Completed'
          ? 'bg-base-dark-green'
          : status === 'Pending'
          ? 'bg-base-orange'
          : status === 'Upcoming'
          ? 'bg-base-purple'
          : status === 'Rejected'
          ? 'bg-base-red'
          : 'bg-base-light-blue'
      }`}
    >
      <p className='font-medium text-sm'>{title}</p>
      {currentView !== Views.MONTH || isVacation ? (
        <div className='flex items-center justify-between text-xs mt-1'>
          <p>{description}</p>
          <p className='font-medium'>{status}</p>
        </div>
      ) : null}
    </div>
  );
};

export default AppointmentCalendarEvent;
